import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import OpbMod from './OpbMod';
import HistoryMng from './HistoryMng';
import CaptureMng from './CaptureMng';
import TemplateMng from './TemplateMng';
// import ModuleMng from './ModuleMng';
import OpbFloorsMng from './OpbFloorsMng';
import ContentsMng from './ContentsMng';
import OpbPreview from './OpbPreview';
import BottomButton from './BottomButton';
import Confirm from '../Dialog/Confirm';
import { templateMngService } from '../../services';
import { alertActions } from '../../modules/alert';

const styles = (theme) => ({
    DialogTitle: {
        padding: theme.spacing(2),
    },
    navButton: {
        position: 'absolute',
        left: theme.spacing(2),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    alertIcon: {
        textAlign: 'center'
    },
});

class PropertiesDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            open2: false,
            previewOpbInfo: null,
            previewOpen: false,
            kind: "move",  // move 탭이동, close 팝업닫기
            navBar: false,
            activeTabId: 1,
            opbInfoStatus: false,
            opbInfo: {
                ...props.opbInfo,
                templateID: props.opbInfo.templateID ? props.opbInfo.templateID : 0,
                themeID: props.opbInfo.themeID ? props.opbInfo.themeID : 0,
                deleteList: [],
                pubType: "derv", // derv = 예약배포, now = 즉시배포
            },
            mode: props.mode, // opb = 현장정보, template = 기본설정, content = 컨텐츠설정

            templateList: [],
            refresh: false,
            isMobile: false,
        }

        if (props.mode !== "opb") this.getTemplateLists();
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    // 현장정보 수정
    setOpbInfoStatus = () => {
        this.setState({
            opbInfoStatus: true,
        });
    };

    // 층설정 수정
    setFloorsStatus = (name, value) => {
        this.setState({
            opbInfo: {
                ...this.state.opbInfo,
                [name]: value,
                floorsStatus: true,
            }
        }, () => { console.log("floor정보 변경"); console.log(this.state.opbInfo); });
    };

    // 캡쳐 새로고침
    handleRefreshButton = () => {
        this.setState({
            refresh: !this.state.refresh
        });
    }

    handleNavBar = () => {
        this.setState({
            navBar: !this.state.navBar
        });
    };

    handleMoveConfirm = (tabId) => {
        if (this.state.opbInfoStatus) {
            this.setState({
                open2: true,
                kind: tabId,
            });
        }
        else {
            // 수정 내용을 그대로 가지고 이동
            this.setState({
                activeTabId: tabId,
                opbInfo: {
                    ...this.state.opbInfo,
                    pubType: "derv",
                },
                navBar: false
            });
        }
    };

    setActiveTabId = (tabId) => {
        this.setState({
            ...this.state,
            activeTabId: tabId,
            opbInfoStatus: false,
            opbInfo: {
                ...this.props.opbInfo,
                pubType: "derv",
            },
            navBar: false
        });
    };

    // PropertiesDialog 팝업창 닫기 전 수정사항이 있을 경우 알림창 열기
    handleConfirm = () => {
        if (this.state.opbInfoStatus || this.state.opbInfo.templateStatus || this.state.opbInfo.floorsStatus || this.state.opbInfo.promotionStatus || this.state.opbInfo.marketingStatus) {
            this.setState({
                open2: true,
                kind: "close"
            });
        }
        else this.handleClose();
    };

    // PropertiesDialog 팝업창 닫기
    handleClose = () => {
        this.setState({
            open: false
        });
        // 팝업 닫으면서 선택한 OPB정보 제거
        this.props.selectedOpbInfoRefresh();
    };


    // confirm창 닫기
    handleConfirmClose = () => {
        this.setState({
            open2: false,
        });
    };


    // 예약배포(derv), 즉시배포(now) 값 변경
    handlePubTypeChange = (value) => {
        this.setState({
            opbInfo: {
                ...this.state.opbInfo,
                pubType: value,
            }
        });
    };

    // 미리보기 창 열기
    handleClickOpenPreview = () => {
        this.setState({
            previewOpbInfo: this.state.opbInfo,
            previewOpen: true
        });
    };
    // 미리보기 창 닫기
    handleClosePreview = () => {
        this.setState({
            previewOpbInfo: null,
            previewOpen: false
        });
    };


    render() {
        const { classes, opbInfo } = this.props;

        const { activeTabId } = this.state;
        let title = 
            activeTabId === 1 ? "(현장 정보)" :
            activeTabId === 2 ? "(수정 이력)" :
            activeTabId === 3 ? "(원격 화면 캡처)" :
            activeTabId === 6 ? "(층 설정)" : "";
        return (
            <> 
                <Dialog className="dialog-wrapper dialog-properties" fullScreen={this.state.isMobile} fullWidth={true} scroll={'paper'} onClose={this.handleConfirm} aria-labelledby="customized-dialog-title" open={this.state.open}>
                    <DialogTitle disableTypography className={classes.DialogTitle}>
                        {this.state.isMobile
                        ? <>
                            <IconButton aria-label="menu" className={classes.navButton} onClick={this.handleNavBar}>
                                <MenuIcon />
                            </IconButton>
                            <h2 className="s-page-tit text-align-center">{opbInfo.opbNo}호기 {title}</h2>
                          </>
                        : <>
                            <h2 className="s-page-tit text-align-center">({opbInfo.siteNum}) {opbInfo.siteName} {'>'} {opbInfo.opbNo}호기 {title}</h2>
                          </>
                        }
                        <IconButton aria-label="close" className={classes.closeButton} onClick={this.handleConfirm}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div className="dialog-content">
                            <div className={`dialog-properties-navbar${(this.state.isMobile ? (this.state.navBar ? "" : "-collapse") : "")}`}>
                                <div className="dialog-properties-navbar-active">
                                        <h6 className="text-align-left" onClick={() => this.handleMoveConfirm(1)}>현장 정보</h6>
                                        <h6 className="text-align-left" onClick={() => this.handleMoveConfirm(2)}>수정 이력</h6>
                                        <h6 className="text-align-left" onClick={() => this.handleMoveConfirm(3)}>원격 화면 캡쳐</h6>
                                        <h6 className="text-align-left" onClick={() => this.handleMoveConfirm(6)}>층 설정{this.state.opbInfo.floorsStatus && "(미등록)"}</h6>
                                </div>
                                <div className="dialog-properties-navbar-inactive"></div>
                            </div>
                            <div className="dialog-properties-main">
                                {this.state.activeTabId === 1 &&
                                    <>
                                        <OpbMod opbInfo={this.state.opbInfo} opbInfoStatus={this.state.opbInfoStatus} stateRefresh={this.props.selectedOpbInfoRefresh} mode='opbstate' setOpbInfoStatus={this.setOpbInfoStatus} />
                                    </>
                                }
                                {this.state.activeTabId === 2 &&
                                    <>
                                        <HistoryMng opbID={this.state.opbInfo.opbID} />
                                    </>
                                }
                                {this.state.activeTabId === 3 &&
                                    <>
                                        <CaptureMng opbInfo={this.state.opbInfo} refresh={this.state.refresh}/>
                                        <BottomButton opbInfo={this.state.opbInfo} mode="capture" handleRefreshButton={this.handleRefreshButton}/>
                                    </>
                                }
                                {this.state.activeTabId === 6 &&
                                    <>
                                        <OpbFloorsMng floorsList={this.state.opbInfo.floorsList} setFloorsStatus={this.setFloorsStatus} />
                                        <BottomButton opbInfo={this.state.opbInfo} mode="floors" activeTabId={this.state.activeTabId} handleMoveConfirm={this.handleMoveConfirm} />
                                    </>
                                }
                                {this.state.activeTabId === 9 &&
                                    <>
                                        <OpbPreview opbInfo={this.state.previewOpbInfo} open={this.state.previewOpen} handleClosePreview={this.handleClosePreview} />
                                        <div className="s-cont-wrap">
                                            <div className="s-flex-auto">
                                                <div id="settingSelectBox" className="s-set-range">
                                                    <div className={`s-set-item s-sel-one dialog-properties-pubType ${this.state.opbInfo.pubType === "derv" ? "active" : ""}`} onClick={() => { this.handlePubTypeChange("derv") }}>
                                                        <strong className="s-tit">예약 배포</strong>
                                                        <img className="s-icon" alt="" src="/assets/images/ic-distribution-02.png" />
                                                        <p className="s-desc">다음날 새벽 0시에 순차적으로 배포 진행</p>
                                                    </div>
                                                    <div className={`s-set-item s-sel-one dialog-properties-pubType ${this.state.opbInfo.pubType !== "derv" ? "active" : ""}`} onClick={() => { this.handlePubTypeChange("now") }}>
                                                        <strong className="s-tit">즉시 배포</strong>
                                                        <img className="s-icon" alt="" src="/assets/images/ic-distribution-01.png" />
                                                        <p className="s-desc">디스플레이에 즉시 배포 진행</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <BottomButton state={this.state} opbInfo={this.state.opbInfo} mode="submit" activeTabId={this.state.activeTabId} handleMoveConfirm={this.handleMoveConfirm} handleClickOpenPreview={this.handleClickOpenPreview} handleClose={this.handleClose} />
                                    </>
                                }
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
                {this.state.open2 === true &&
                    <Confirm message={"취소하시겠습니까?\n입력한 정보는 초기화됩니다."} kind={"fail"} handleFormSubmit={this.state.kind === "close" ? this.handleClose : () => { this.setActiveTabId(this.state.kind) }} handleClose={this.handleConfirmClose} />
                }
            </>
        );
    }
}


function mapState(state) {
    const { alert } = state;
    return { alert };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(withStyles(styles)(PropertiesDialog));